import { useEffect, useState } from "react";

export const AthletesTab = () => {
  const [item, setT] = useState(1);
  useEffect(() => {
    setT(prev => prev +1);
  }, []);

  return <div>{item}</div>;
};
